import * as React from "react";
export function SvgSpacesSmallWorkbooks(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      id="Spaces_Small_Workbooks_svg__Layer_1"
      x={0}
      y={0}
      width={18}
      height={18}
      xmlSpace="preserve"
      {...props}
    >
      <style>{".Spaces_Small_Workbooks_svg__st1{fill:#666767}"}</style>
      <path
        id="Spaces_Small_Workbooks_svg__Line_3_"
        fill="#b3b3b4"
        d="M5 12h7v1H5z"
      />
      <path
        id="Spaces_Small_Workbooks_svg__Bar3"
        className="Spaces_Small_Workbooks_svg__st1"
        d="M10 8h1v3h-1z"
      />
      <path
        id="Spaces_Small_Workbooks_svg__Bar2"
        className="Spaces_Small_Workbooks_svg__st1"
        d="M8 7h1v4H8z"
      />
      <path
        id="Spaces_Small_Workbooks_svg__Bar1"
        className="Spaces_Small_Workbooks_svg__st1"
        d="M6 9h1v2H6z"
      />
      <path
        id="Spaces_Small_Workbooks_svg__Workbook"
        className="Spaces_Small_Workbooks_svg__st1"
        d="M16 8V6h-1V4c0-.5-.5-1-1-1H3c-.5 0-1 .5-1 1v11c0 .5.5 1 1 1h11c.5 0 1-.5 1-1v-1h1v-2h-1v-1h1V9h-1V8h1zm-2 7H3V4h11v11z"
      />
    </svg>
  );
}
